<template>
  <div class="create" @keyup.13="submit">
    <mu-dialog title="新增账户" width="500" :open="open" @close="close">
      <mu-form :model="form" label-position="left" label-width="100" ref="form">
        <mu-form-item prop="name" label="名称">
          <mu-text-field v-model="form.name"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="money" label="金额">
          <mu-text-field v-model="form.money"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="remark" label="备注">
          <mu-text-field v-model="form.remark"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="user" label="账户所属人">
          <mu-select v-model="form.user.id">
            <mu-option
              v-for="(item, index) in allUserList"
              :key="index"
              :label="item.realName"
              :value="item.id"
            ></mu-option>
          </mu-select>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        name: '',
        money: '',
        remark: '',
        user: {
          id: 1
        }
      },
      allUserList: []
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate().then((flag) => {
        if (flag) {
          backend(api.account.create, this.form).then((result) => {
            if (result.statusCode === 200) {
              this.close()
              this.$emit('finish')
              this.form = {
                name: '',
                money: '',
                remark: '',
                user: {
                  id: 1
                }
              }
            }
          })
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    },
    getAllUser() {
      backend(api.user.getAll, { getAll: true }).then((res) => {
        if (res.statusCode === 200) {
          this.allUserList = res.data.rows
        }
      })
    }
  },
  mounted() {
    this.getAllUser()
  }
}
</script>

<style lang="less" scoped>
.create {
}
</style>



// WEBPACK FOOTER //
// src/views/account/create.vue